module.exports = __webpack_public_path__ + "assets/2c47dee8da38f52d3ea6f8e0c152773f.png";